import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { PENDING, IDLE } from "const"
import { CcApprovalLevel, CcApprovalLevelCreate } from "server/models"
import { useInput, StateType } from "client/utils"
import {
    StoreType,
    CcApprovalLevelValidation,
    SaveCcApprovalLevel,
    closeModal,
    setCcApprovalLevelEdit,
    setCcApprovalLevelReloadList,
    setCcApprovalLevelReloadEdit,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    SelectDropdown,
    SelectDropdownItem,
    Feedback,
    Button,
    SpinnerIcon,
} from "client/components"

interface ApprovalLevelEditProps {
    level: CcApprovalLevel
    module: number
}

let isMounted: boolean

const Form = ({
    level,
    module,
}: ApprovalLevelEditProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const groupList = useSelector((state: StoreType) => state.projectGroup.groupList)
    const groupIds = useSelector((state: StoreType) => state.projectGroup.groupIds)

    const modals = useSelector((state: StoreType) => state.system.modals)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [name, setName] = useInput(level.name)
    const [groupId, setGroupId] = useState(level.groupId)
    const [validation, setValidation] = useState<CcApprovalLevelValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    const onClose = () => {
        if (modals.length && isMounted) dispatch(closeModal())
    }

    const onSave = (mode: number) => {
        if (mode === 1) setSaveState(PENDING)
        if (mode === 2) setApplyState(PENDING)

        const group = groupList[groupId]
        const newLevelData: CcApprovalLevelCreate = {
            name,
            accountId: level.accountId || userData.accountId,
            projectId: level.projectId || project.id,
            groupId,
            groupAccountId: group ? group.accountId : null,
            groupProjectId: group ? group.projectId : null,
            module,
            creator: level.id ? level.creator : userData.userId,
            order: level.id ? level.order : 0,
        }

        SaveCcApprovalLevel(level.id, newLevelData, lang)
        .then((res) => {
            if (isMounted) {
                setValidation(res.validation)
                setSaveState(IDLE)
                setApplyState(IDLE)
            }
            if (res.validation) return

            dispatch(setCcApprovalLevelEdit({
                ...newLevelData,
                id: res.newLevelId || level.id,
                order: res.newLevelOrder || level.order,
            }))

            dispatch(setCcApprovalLevelReloadList(false))
            setTimeout(() => {
                dispatch(setCcApprovalLevelReloadList(true))
            }, 0)

            if (mode === 1) onClose()
            if (mode === 2) {
                dispatch(setCcApprovalLevelReloadEdit(false))
                setTimeout(() => {
                    dispatch(setCcApprovalLevelReloadEdit(true))
                }, 0)
            }
        })
    }

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.name}</Label>
                        <Input type="text" value={name} onChange={setName} />
                        <Feedback>{validation && validation.name}</Feedback>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.group}</Label>
                        <SelectDropdown title={groupList[groupId] ? groupList[groupId].name : ""}>
                            {
                                groupIds.map((id) => (
                                    <SelectDropdownItem key={id} onClick={() => setGroupId(id)}>
                                        {groupList[id].name}
                                    </SelectDropdownItem>
                                ))
                            }
                        </SelectDropdown>
                        <Feedback>{validation && validation.groupId}</Feedback>
                    </FormGroup>
                </Col>
                <Col xs={12}>
                    <Button variant="success" row onClick={() => onSave(1)}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                    </Button>
                    <Button variant="success" row onClick={() => onSave(2)}>
                        {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                    </Button>
                    <Button row onClick={onClose}>{lang.cancel}</Button>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
